import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { WidgetState } from 'components/organisms/projects-report/widgets';
import {
  loadingRender,
  noDataMessageFormatter,
  noDataRender,
} from 'components/organisms/projects-report/widgets/renderers';
import { useTranslate, useTranslation } from 'hooks/use-translation';
import { BaseWidget } from '../common';
import { UsersReportRecord } from '../types';
import { WidgetStateError } from './data/use-widget-data';
import { TaskOnTimeCompletionTable } from './tables';

interface Props<T, E> {
  value: WidgetState<T, E>;
}
export const TaskOnTimeCompletionWidget: FC<
  Props<UsersReportRecord[], WidgetStateError>
> = ({ value }) => {
  const translate = useTranslate();
  const resultRenderer = (records: UsersReportRecord[]) => (
    <TaskOnTimeCompletionTable records={records} />
  );

  return (
    <BaseWidget>
      <BaseWidget.Title
        text={useTranslation(
          'reports.users_performance.widget.tasks_on_time_completion.title',
        )}
      />
      <BaseWidget.Content>
        {WidgetState.map(resultRenderer, loadingRender, () =>
          noDataRender(
            noDataMessageFormatter(
              <FormattedMessage id="reports.users_performance.widget.tasks_on_time_completion.no_value" />,
              translate,
            ),
          ),
        )(value)}
      </BaseWidget.Content>
    </BaseWidget>
  );
};
